import { Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FakturPajak } from '../faktur-pajak';
import { Transaksi } from '../transaksi';
import { QrScannerComponent } from 'angular2-qrscanner';
import { start } from 'repl';
import {Angular5Csv} from 'angular5-csv/Angular5-csv';
import * as os from 'os';
import { MatTableDataSource,
  MatTable, MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSlideToggle,
  MatSlideToggleChange,
  MatSelect,
  MatSelectChange,
  MatInput,
  MatList} from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import {Howl} from 'howler';
import {StringShufflerPipe} from '../string-shuffler.pipe';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument, DocumentChangeAction} from 'angularfire2/firestore';
import {RowAnimation} from '../row-animation';
import { FormControl, Validators } from '@angular/forms';
import { v4 } from 'uuid';
import { Session, Device } from '../session';
import { Observable } from 'rxjs/Observable';
import { SHA512, AES } from 'crypto-js';
import { EncryptionKeyService } from '../encryption-key.service';
import { AdjustPeriodePajakComponent, PeriodePajak } from './adjust-periode-pajak/adjust-periode-pajak.component';

@Component({
  selector: 'app-faktur-pajak-masukan',
  templateUrl: './faktur-pajak-masukan.component.html',
  styleUrls: ['./faktur-pajak-masukan.component.css'],
  animations: [RowAnimation]
})

export class FakturPajakMasukanComponent implements OnInit, AfterViewInit {

  private displayedColumns = [
    'nomor_faktur',
    'nama_penjual',
    'tanggal_faktur',
    'jumlah_dpp',
    'jumlah_ppn',
    'jumlah_ppnbm',
    'status_approval',
    'periode_pajak',
    'more'
  ];

  private data: FakturPajak[] = [];
  private chosenDev: MediaDeviceInfo;
  private mediaDevices: MediaDeviceInfo[];
  private allowFetching: Boolean = false;
  private webcamtoggled: Boolean = false;
  private audio: HTMLAudioElement;
  private sound: Howl;
  private scannedURL: String;
  private url_error_string: String;
  private token: string;
  private sessionID: string;
  private sessionDoc: AngularFirestoreDocument<any>;
  private sessionMembers: AngularFirestoreCollection<Device>;
  private dataSessionChangeAction: Observable<DocumentChangeAction[]>;
  private session: Session = new Session();
  private connectedDevices: Device[] = [];
  private showQRCode: Boolean = false;
  private p: string;

  scannedURLFormControl = new FormControl('');

  @ViewChild(QrScannerComponent) scanner: QrScannerComponent;
  @ViewChild(MatSlideToggle) webcamOnOff: MatSlideToggle;
  @ViewChild(MatSelect) videoSelector: MatSelect;
  @ViewChild(MatTable) table: MatTable<FakturPajak>;
  @ViewChild(MatInput) manualURL: MatInput;
  @ViewChild(MatList) connectedDevicesListView: MatList;
  // @ViewChild(MatTable) mobileScanner: MatTable<Device>;

  constructor(private http: HttpClient,
  private dialog: MatDialog,
  private shuffler: StringShufflerPipe,
  private auth: AngularFireAuth,
  private afs: AngularFirestore,
  private encryptionkey: EncryptionKeyService) {}

  ngOnInit() {
    this.toggleWebcam();
    this.initSound();
    this.fetchUserToken();
    this.initializeSession();
  }

  ngAfterViewInit() {
    // INFORM USER THAT DO NOT REFRESH THE PAGE AFTER IT's LOADED
    this.openDialog('Jangan menekan tombol refresh untuk halaman ini tanpa tujuan yang jelas' +
    ' karena semua faktur yang sudah berhasil dipindai dan perangkat yang terhubung akan putus', 'Informasi');
  }

  private initializeEncryptionKey() {
    this.p = 'fm://' + this.session.getEncryptedSessionID(this.encryptionkey.getEncryptionKey());
  }

  private initializeSession() {
    this.sessionID = v4();
    this.sessionDoc = this.afs.collection('session').doc(this.sessionID);
    this.sessionDoc.ref.get()
    .then(doc => {
      if (doc.exists) {
        return Promise.reject('exists');
      } else {
        return this.initializeSessionDoc(this.sessionDoc);
      }
    })
    .then(result => {
      this.initializeSessionMembersCollection();
      this.initializeDataSessionChangeAction();
    })
    .catch(e => {
      if (e === 'exists') {
        this.initializeSession();
      } else {
        this.openDialog(e.toString(), 'Error');
      }
    });
  }

  private initializeDataSessionChangeAction() {
    this.dataSessionChangeAction = this.afs.collection(this.sessionID).stateChanges(['added', 'removed', 'modified']);
    this.dataSessionChangeAction
    .forEach(a =>
      a.forEach(b => {
        const doc = b.payload.doc;
        const fp = FakturPajak.getFakturPajakFromJson(doc.data());
        const index = this.data.findIndex(toFind => toFind.nomor_faktur === fp.nomor_faktur);
        const type = b.type;
        if ( type === 'added') {
          if (fp && index === -1) {
            this.addResultToTable(fp);
          }
        }

        if ( type === 'removed') {
          if (index > -1) {
            this.deleteRow(index);
          }
        }

        if (type === 'modified') {
          if (fp && index > -1) {
            this.data[index] = fp;
            this.table.renderRows();
          }
        }
      })
    );
  }

  private initializeSessionMembersCollection() {
    this.sessionMembers = this.afs.collection('session_members', ref => ref.where('session_id', '==', this.sessionID));
    this.sessionMembers.stateChanges(['added', 'removed', 'modified']).forEach(a =>
      a.forEach(b => {
        const doc = b.payload.doc;
        const device = Device.getDeviceFromJson(doc.data());
        const type = b.type;
        const index = this.connectedDevices.findIndex(toFind => toFind.device_id === device.device_id);
        if (type === 'added') {
          // Check for new line or what
          if (index < 0) {
            this.connectedDevices.unshift(device);
            // this.mobileScanner.renderRows();
          }
        } else if (type === 'removed') {
          if (index > -1) {
            this.connectedDevices.splice(index, 1);
            // this.mobileScanner.renderRows();
          }
        } else if (type === 'modified') {
          if (index > -1) {
            this.connectedDevices[index] = device;
            // this.mobileScanner.renderRows();
          }
        }
      }
    ));
  }

  private initializeSessionDoc(doc: AngularFirestoreDocument<any>): Promise<void> {
    const now = Date.now();
    const data = {
      expire : now + 10800000,
      id : this.sessionID,
      started: now,
      name: this.getSessionName()
    };
    this.sessionDoc.snapshotChanges().forEach(a => {
      this.session = Session.getSessionFromJson(a.payload.data());
    });
    return doc.set(data);
  }

  private fetchUserToken() {
    this.auth.auth.currentUser.getIdToken()
    .then(t => {
        this.token = t.toString();
        this.allowFetching = true;
    })
    .catch(e => {
      this.openDialog('Error Getting Token From Server please try again', 'Error');
    });
  }

  private initSound(): void {
    this.sound = new Howl({
      src: ['../../assets/beep.mp3'],
      html5: true
    });
  }

  private playBeepSound(): void {
    this.sound.play();
  }

  private initializeWebCam() {
    this.scanner.getMediaDevices().then(devices => {
      const videoDevices: MediaDeviceInfo[] = [];
      for (const device of devices) {
        if (device.kind.toString() === 'videoinput') {
          videoDevices.push(device);
        }
      }
      if (videoDevices.length > 0) {
        this.mediaDevices = videoDevices;
        for (const dev of videoDevices) {
          if (dev.label.includes('front') || dev.label.includes('facetime')) {
            this.chosenDev = dev;
          }
        }
        if (this.chosenDev) {
          this.scanner.chooseCamera.next(this.chosenDev);
        } else {
          this.chosenDev = videoDevices[0];
          this.scanner.chooseCamera.next(videoDevices[0]);
        }
        this.videoSelector.value = this.chosenDev;
      }
    });
    this.scanner.capturedQr.subscribe(res => {
      this.fetchFakturPajak(res);
    });
  }

  private startScanning(): void {
    if (this.chosenDev) {
      this.scanner.startScanning(this.chosenDev);
    } else {
      this.initializeWebCam();
    }
  }

  private videoSelectorSelectionChanged(value: MatSelectChange) {
    if (value.value) {
      this.chosenDev = <MediaDeviceInfo>value.value;
      this.scanner.stopScanning();
      this.startScanning();
    }
  }

  private toggleWebcam() {
    if (!this.webcamtoggled) {
      this.startScanning();
    } else {
      this.scanner.stopScanning();
      this.webcamOnOff.checked = false;
    }
    this.webcamtoggled = !this.webcamtoggled;
    this.webcamOnOff.checked = Boolean(this.webcamtoggled);
  }

  fetchFakturPajak(url: string) {
    if (this.allowFetching) {
      if (this.isUrlValid(url) && this.token != null) {
        this.scannedURL = url;
        this.allowFetching = false;
        this.playBeepSound();
        // const server = 'https://api.efaktur.keyklik.com/fm';
        // const server = 'http://localhost:5000/efaktur-75f43/us-central1/api/fm';
        const server = 'https://us-central1-efaktur-75f43.cloudfunctions.net/api/fm';
        const body = {
          url : url
        };
        const headers = new HttpHeaders({
          'Accept' : 'application/json',
          'Authorization' : 'Bearer ' + this.token,
          'Content-Type' : 'application/json'
        });
        this.http.post(server, body,
        {
          observe: 'response',
          headers: headers
        })
        .subscribe(res => {
          if (res.ok) {
            const fp = FakturPajak.getFakturPajakFromJson(res.body);
            if (fp.nomor_faktur) {
              const result = this.data.filter((a, i, ar) => {
                return a.nomor_faktur === fp.nomor_faktur;
              });
              if (result.length === 0) {
                this.addResultToTable(fp);
                // this.data.unshift(fp);
                // this.table.renderRows();
                this.allowFetching = true;
              } else {
                // DUPLICATE NOMOR FAKTUR PAJAK INFORM USER;
                const r = result[0];
                this.openDialog(`Faktur ${r.nomor_faktur} sudah pernah discan sebelumnya`, 'Error');
              }
            }
          } else {
            this.openDialog('adanya kesalahan dalam mengunduh faktur pajak silahkan coba dipindai lagi', 'Error');
          }
        },
        error => {
          this.openDialog(error.message, 'Error');
        });
        this.scannedURL = null;
      } else {
        this.openDialog('Gagal dalam mendapatkan token atau format url faktur bermasalah', 'Error');
        this.allowFetching = true;
      }
    }
  }

  private manuallySubmitUrl(obj: any): void {
    if (this.isUrlValid(this.scannedURL)) {
      this.fetchFakturPajak(this.scannedURL.toString());
    }
  }

  private addResultToTable(fp: FakturPajak) {
    this.data.unshift(fp);
    this.table.renderRows();
  }

  private isUrlValid(userInput) {
    const res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    if (res == null) {
      return false;
    } else {
      return true;
    }
  }

  private openDialog(_body: string, _title: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        title: _title,
        body: _body
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.allowFetching = true;
    });
  }

  private webCamSlideChanged(value: MatSlideToggleChange) {
    this.toggleWebcam();
  }

  private deleteRow(index: number): void {
    if (index != null) {
      this.data.splice(index, 1);
      this.table.renderRows();
    }
  }

  private clearAll(): void {
    this.data.length = 0;
    this.table.renderRows();
  }

  private exportToCSV(): void {
    const userid = this.auth.auth.currentUser.uid;
   const filename = this.shuffler.transform(userid) + '-' + Date.now().toString();
   const _data = [];
   if (this.data.length > 0) {
    for (const d of this.data) {
      const object = {
        FM : 'FM',
        KD_JENIS_TRANSAKSI : d.kode_jenis_transaksi,
        FG_PENGGANTI : d.fg_pengganti,
        NOMOR_FAKTUR : d.nomor_faktur,
        MASA_PAJAK : d.masa_pajak,
        TAHUN_PAJAK : d.tahun_pajak,
        TANGGAL_FAKTUR : d.getFormattedDate(),
        NPWP : d.npwp_penjual,
        NAMA : d.nama_penjual.replace(/,/g, ' ').replace(/\./g, ' '),
        ALAMAT_LENGKAP : d.alamat_penjual.replace(/,/g, ' ').replace(/\./g, ' '),
        JUMLAH_DPP : d.jumlah_dpp,
        JUMLAH_PPN : d.jumlah_ppn,
        JUMLAH_PPNBM : d.jumlah_ppnbm,
        IS_CREDITABLE : ''
      };
      _data.push(object);
    }
    const _ = new Angular5Csv(_data, filename, {
      showLabels: true,
      quoteStrings: '',
      headers: [
        'FM',
        'KD_JENIS_TRANSAKSI',
        'FG_PENGGANTI',
        'NOMOR_FAKTUR',
        'MASA_PAJAK',
        'TAHUN_PAJAK',
        'TANGGAL_FAKTUR',
        'NPWP',
        'NAMA',
        'ALAMAT_LENGKAP',
        'JUMLAH_DPP',
        'JUMLAH_PPN',
        'JUMLAH_PPNBM',
        'IS_CREDITABLE'
      ]
    });
   }
  }
  private toggleQrCode() {
    this.initializeEncryptionKey();
    this.showQRCode = !this.showQRCode;
  }

  private getSessionName(): string {
    let display_name = this.auth.auth.currentUser.displayName.replace(' ', '');
    if (display_name) {
      display_name += '-' + this.sessionID.substr(this.sessionID.length - 5);
      return display_name.toLocaleLowerCase();
    } else {
      return this.sessionID.substr(this.sessionID.length - 10).toLocaleLowerCase();
    }
  }

  private openAdjustPeriodePajakDialog(index: number) {
    const ref = this.dialog.open(AdjustPeriodePajakComponent, {
      width: '320px',
      data: this.data[index]
    });
    ref.afterClosed().subscribe(res => {
      if (res) {
        const pp = res as PeriodePajak;
        if (this.data[index].masa_pajak !== pp.month || this.data[index].tahun_pajak !== pp.year) {
          this.data[index].masa_pajak = pp.month;
          this.data[index].tahun_pajak = pp.year;
          this.table.renderRows();
        }
      }
    },
    err => {

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/faktur-pajak-masukan/faktur-pajak-masukan.component.ts